import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";
import GlobalCatalogViewDetails, {
  GlobalCatalogDeletePopUp,
} from "../GlobalCatalogViewDetails";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN } from "../../../../../store/types";
const CategoryHead = (props) => {
  return (
    <tr>
      <th style={{ width: "20%" }}>
        Category <br />
        ID
      </th>
      {/* <th style={{ width: "10%" }}>Icon</th> */}
      <th style={{ width: "10%" }}>Name</th>
      <th style={{ width: "27%" }}>Description</th>
      <th style={{ width: "8%" }}>
        No. <br />
        Items
      </th>
      <th className="f11-500" style={{ width: "18%" }}>
        Status
      </th>
      {/* <th style={{ width: "10%" }}>Status</th> */}
      <th style={{ width: "15%" }}>
        Created Date <br />& Time
      </th>
      <th style={{ width: "20%" }}>Actions</th>
    </tr>
  );
};

export default CategoryHead;

export const CategoryBody = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const takeToCategoryEditPage = (data) => {
    dispatch({
      type: SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN,
      payload: data,
    });
    if (props.type === "chain") {
      history.push("/superadmin-chain-catalogue/add-category");
    } else {
      history.push("/superadmin-global-catalogue/add-category");
    }
  };
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row"
                // style={{ textAlign: "center" }}
                onClick={showTr}
              >
                <td style={{ width: "20%" }}>
                  <div className="f12-500 text-break">
                    #ID {props && props.item && props.item._id}
                  </div>
                </td>
                {/* <td style={{ width: "10%" }}> */}
                {/* <Image
                    src={
                      props.item.veg
                        ? require("../../../../../assets/images/superadmin/ordericon/veg.svg")
                        : require("../../../../../assets/images/superadmin/ordericon/non veg.svg")
                    }
                    alt="veg"
                    title="veg"
                    width="20px"
                    fluid
                  /> */}
                {/* </td> */}
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {props && props.item && props.item.name}
                  </div>
                  {/* {props &&
                    props.item &&
                    props.item.category &&
                    props.item.category.name} */}
                </td>
                <td style={{ width: "27%" }}>
                  <div className="f12-500">
                    {props && props.item && props.item.description}
                  </div>
                </td>
                <td
                  style={{ width: "8%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div className="f12-500" style={{ color: "#2196F3" }}>
                    {props && props.item && props.item.items.length}
                  </div>
                </td>
                {/* <td style={{ width: "10%" }} className="d-flex">
                  <Toggle
                    checked={props.item && props.item.auto_accept}
                    // toggleFunction={() =>
                    //   changeAutoAccept(props.item.auto_accept)
                    // }
                    // toggleFunction={toggleFunction}
                  />{" "}
                </td> */}
                <td
                  style={{ width: "18%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  {/* No{" "} */}
                  <Toggle
                    checked={props.item && props.item.status}
                    toggleFunction={() => props.changeCategoryStatus()}
                    disabled={true}
                    // toggleFunction={() =>
                    //   changeAutoAccept(props.item.auto_accept)
                    // }
                    // toggleFunction={toggleFunction}
                  />{" "}
                  {/* Yes */}
                </td>
                <td style={{ width: "15%" }}>
                  {" "}
                  <div className="f12-500">
                    {moment(props && props.item && props.item.updatedAt).format(
                      "DD MMM YYYY"
                    )}{" "}
                    <br />
                    {moment(props && props.item && props.item.updatedAt).format(
                      "LT"
                    )}
                  </div>
                </td>
                <td
                  style={{ width: "20%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div className="d-flex">
                    {/* {props.show === false ? (
                      <> </>
                    ) : (
                      <GlobalCatalogViewDetails
                        data={props && props.item}
                        types={props.type}
                      />
                    )} */}
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      // onClick={() => {
                      //   setShow(true);
                      // }}
                    >
                      <Image
                        src={require("../../../../../assets/images/UserManagement/eye.svg")}
                        alt="View Chin Category"
                        title="View Chin Category"
                        fluid
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={() => takeToCategoryEditPage(props.item)}
                    >
                      <Image
                        src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>{" "}
                    <GlobalCatalogDeletePopUp
                      title="Delete Category"
                      subtitle="Are you sure you want to delete this category?"
                      type="category"
                      deleteCategory={() => props.deleteCategory()}
                    />
                    {/* <GlobalCatalogViewDetails /> */}
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <tr
                  className="sd_accordion_body"
                  style={{ background: "#ffffff" }}
                >
                  <div className="container-fluid mb-3">
                    <hr />
                    <div className="row">
                      <div className="col-3 f14-500">
                        Category Classification
                      </div>
                      <div className="col-3 f14-500">Item Classification</div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3 f12-500">
                        {props &&
                          props.item &&
                          props.item.category_classification}
                      </div>
                      <div className="col-3 f12-500">
                        {" "}
                        {props &&
                          props.item &&
                          props.item.product_classification}
                      </div>
                    </div>
                  </div>
                </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
